export default __webpack_public_path__ + "static/tab-img11-30dd518bc9dbd426a205c15a36355cb2.png";